import { REWARD_DEFS, canClaimReward } from "../services/ads/rewardRules";
import { Button } from "./Button";

export function RewardPanel({ controller }) {
	const state = controller.stateRef.current;
	const rewardBusy = controller.busy.rewarding;

	return (
		<section className="panel reward-panel">
			<div className="panel__heading">
				<div>
					<div className="eyebrow">Optional Rewards</div>
					<h2>Supply Relay</h2>
				</div>
			</div>
			<div className="reward-list">
				{Object.entries(REWARD_DEFS).map(([id, reward]) => {
					const check = canClaimReward(state, id);
					const disabled = rewardBusy || !check.ok;
					return (
						<article key={id} className="reward-card">
							<div>
								<strong>{reward.title}</strong>
								<p>{reward.desc}</p>
								{!check.ok && <small>{check.reason}</small>}
								{rewardBusy && <small>Preparing ad...</small>}
							</div>
							<Button tone={!disabled ? "primary" : "ghost"} disabled={disabled} onClick={() => controller.actions.claimReward(id)}>
								{rewardBusy ? "Opening..." : "Claim"}
							</Button>
						</article>
					);
				})}
			</div>
		</section>
	);
}
